import useMediaQuery from '@mui/material/useMediaQuery';

import { screens } from './screens';

export type DsScreen = keyof typeof screens;

/**
 * JS counterpart to the `ds-*:` variants, for layouts that must mount a
 * component in one place rather than hide a copy with CSS.
 *
 * @param {DsScreen} screen breakpoint name from screens.js
 * @returns {boolean} whether the viewport is at least that wide
 */
export default function useDsScreen (screen: DsScreen) {
  return useMediaQuery(`(min-width: ${screens[screen]})`);
}
